import { api } from '../utils/apiClient';

export const analyticsService = {
  async getDashboard() {
    return api.get('/analytics/dashboard');
  },

  async getKPIs() {
    return api.get('/analytics/kpis');
  },

  async getGeos() {
    return api.get('/analytics/geos');
  },

  async getFeed() {
    return api.get('/feed');
  },

  async getAnalyticsPage() {
    return api.get('/analytics/full');
  },
};
